import { TooltipProvider } from "@/components/ui/tooltip";
import { AIChatRuntimeProvider } from "../providers/ai-chat-runtime-provider";
import { AIChatModal } from "./ai-chat-modal";

/**
 * AI Chat Widget - Main component that manages the AI chat interface
 * Uses @assistant-ui/react for the UI and runtime
 * Should be placed at the app root level to work globally
 */
export function AIChatWidget() {
  return (
    <TooltipProvider>
      <AIChatRuntimeProvider>
        <AIChatModal />
      </AIChatRuntimeProvider>
    </TooltipProvider>
  );
}
